import {useState,useEffect} from 'react'
import realtimeDB from '../Utils/api'

const useInfoCustomers = () => 
{   
    const [TotalPartys, setTotalPartys] = useState(undefined);
    const [TotalDiners, setTotalDiners] = useState(undefined)

    useEffect(() => 
    {
        const CustomersRef=realtimeDB.ref("/Customers");

        CustomersRef.on("value",snapshot =>
        {
            let totalPartys=0;
            let totalDiners=0;
            snapshot.forEach(customer =>
            {
                const {status,dinersCount}=customer.val();
                
                if(status!=="no-info" && status!=="cancelled" && status!=="served")
                {
                    totalDiners+= Number(dinersCount);
                    totalPartys+=1;
                }
            });

            setTotalPartys(totalPartys);
            setTotalDiners(totalDiners);
        });

        return ()=> CustomersRef.off();
    }, [])

    return {TotalPartys,TotalDiners};
}

export default useInfoCustomers
